import * as types from './types';
import { loading } from 'State/actions';
import { setUserSetting } from 'Common/UserSettings/state/actions';
import { UserSettingsEnum } from 'Common/UserSettings/helpers/helper';
import { getId } from 'Common/Security/state/selectors';
import { isNumber } from 'util';
import _ from 'lodash';

export const getSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const state = getState();
      const userId = getId(state);
      const response = await MPWWebApi.postGenericInsertUpdate(
        'SiteMaster/AccessibleSites',
        userId
      );

      dispatch({
        type: types.CEP_FUNDS_DUE_REPORT_GET_SITES,
        payload: _.get(response, 'data.Data', []),
      });
    } catch (error) {
      dispatch({
        type: types.CEP_FUNDS_DUE_REPORT_ERROR,
        payload: error.response,
      });
    }
  };
};

export const setSelectedSites = sites => {
  return {
    type: types.CEP_FUNDS_DUE_REPORT_SET_SELECTED_SITES,
    payload: sites,
  };
};

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CEP_FUNDS_DUE_REPORT_LOADING, true));

    try {
      dispatch(
        setUserSetting(getState(), {
          key: UserSettingsEnum.CEPFundsDueBFSTAmountDue,
          value: isNumber(parseFloat(data.AmtDueBfst))
            ? parseFloat(data.AmtDueBfst)
            : null,
        })
      );

      dispatch(
        setUserSetting(getState(), {
          key: UserSettingsEnum.CEPFundsDueLUNCHAmountDue,
          value: isNumber(parseFloat(data.AmtDueLunch))
            ? parseFloat(data.AmtDueLunch)
            : null,
        })
      );

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/CEPFundsDue',
        data
      );

      dispatch({
        type: types.CEP_FUNDS_DUE_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.CEP_FUNDS_DUE_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.CEP_FUNDS_DUE_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.CEP_FUNDS_DUE_REPORT_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/cepfundsdue/state/report/actions.js